import {
  PROGRESSBAR_VIEW_REQUEST,
  PROGRESSBAR_VIEW_SUCCESS,
  PROGRESSBAR_VIEW_FAIL,
} from "../constants/AuthConstant";
import axios from "axios";

export const ProfileProgressBarAction = (id) => async (dispatch) => {
  dispatch({
    type: PROGRESSBAR_VIEW_REQUEST,
    payload: true,
  });

  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_PATH}/ebench/get_progress`,
      {
        params: { candidateId: id },
        headers: { "content-type": "application/json" },
      }
    );

    dispatch(loadAllDetailsPre(res.data));
  } catch (error) {
    dispatch({
      type: PROGRESSBAR_VIEW_FAIL,
      payload: false,
      error,
      msg: "Failed to load the information",
    });
  }
};

export const loadAllDetailsPre = (data) => ({
  type: PROGRESSBAR_VIEW_SUCCESS,
  result: data,
  payload: false,
  msg: "SUCCESS",
});
